// 负责订单摘要展示，与 Mock 支付页和订单结果页关联。
import { formatCurrency } from "../../domain/cart";
import type { Order } from "../../domain/orders";

type OrderSummaryProps = {
  order: Order;
};

export const OrderSummary = ({ order }: OrderSummaryProps) => {
  return (
    <aside className="order-summary" aria-label="Order summary">
      <div>
        <p>Order summary</p>
        <h2>{order.id}</h2>
        <span>{order.customer.email}</span>
      </div>

      <div className="summary-lines">
        {order.lines.map((line) => (
          <div className="summary-line" key={`${line.productId}-${line.size}`}>
            <div>
              <strong>{line.name}</strong>
              <span>
                Size {line.size} - Qty {line.quantity}
              </span>
            </div>
            <span>{formatCurrency(line.lineTotal)}</span>
          </div>
        ))}
      </div>

      <div className="summary-totals">
        <div>
          <span>Subtotal</span>
          <strong>{formatCurrency(order.totals.subtotal)}</strong>
        </div>
        <div>
          <span>Shipping</span>
          <strong>
            {order.totals.shipping === 0
              ? "Free"
              : formatCurrency(order.totals.shipping)}
          </strong>
        </div>
        <div>
          <span>Total</span>
          <strong>{formatCurrency(order.totals.total)}</strong>
        </div>
      </div>
    </aside>
  );
};
